import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  notification } from "antd";
import { apiServices } from "../../services/Api.js";


//get Advisors
export const getAdvisors = createAsyncThunk(
    "advisors/getAdvisors",
    async () => {
        try {
            const response = await apiServices.get(`advisors`);
            console.log("advisors data", response);
            return response.data; // Extract data from the response object
        } catch (error) {
            console.error("Error fetching advisors:", error);
            throw error;
        }
    }
);

//get single Advisor


const initialState = {
    data: [],
    loading: false,
    advisor:[],
    error: ""
};

const advisorsSlice = createSlice({
    name: "advisors",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getAdvisors.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAdvisors.fulfilled, (state, action) => {
                state.loading = false;
                state.data = [action.payload];
            })
            .addCase(getAdvisors.rejected, (state) => {
                state.loading = false;
                state.error = "Error while fetching advisors details";

                if (state.error) {
                    notification.error({
                        message: state.error
                    });
                }
            });
    },
});

const advisorsReducer = advisorsSlice.reducer;

export default advisorsReducer;
